/* eslint-disable array-callback-return */
import { put, takeEvery, takeLatest } from "redux-saga/effects";
import _ from "underscore";
import * as ZoneService from "../../secure/services/zoneService";
import * as TemplateService from "../../secure/services/templateService";
import * as actions from "../actions/zoneActions";
import * as actionsLoader from "../actions/loaderActions";
import * as templateActions from "../actions/templateActions";
import * as actionTypes from "../actions/actionTypes";
import APP_CONST from "../../core/shared/constants";
import { StorageHelper } from "../../../utils/storageHelper";
import * as UtilsHelper from "../../../utils/utilsHelper";
import i18n from "i18next";

export function* fetchAllClientApiSaga() {
  try {
    yield put(actions.showZoneLoader());

    const apiInitConfigResponse = yield ZoneService.doGetAppInitConfig();
    if (apiInitConfigResponse?.status === 200) {
      const appConfigResult = apiInitConfigResponse.data;
      yield put(actions.getAppInitConfigSuccess(appConfigResult.result));
    } else {
      yield put(actionsLoader.showError(apiInitConfigResponse?.statusText, "error", "warning"));
    }

    const getViedocInfo = yield ZoneService.doGetViedocInfo();
    if (getViedocInfo?.status === 200) {
      const result = getViedocInfo.data.result;
      const orgInfo = result.orgInfo.orgGuid;
      const studyInfo = result.studyInfo;
      const userInfo = result.userInfo;
      const users = result.users;
      const usersRole = result.usersRole;

      yield put(actions.getRoleListSuccess(usersRole));
      yield put(actions.getStudyInfoSuccess(studyInfo));
      StorageHelper.clearRecentSearchInfo();
      yield put(actions.goToBrowserView());
      yield put(actions.getUserInfoSuccess(userInfo));
      yield put(actions.getUserListSuccess(users));
      yield put(actions.getOrgId(orgInfo));
    } else {
      yield put(actionsLoader.showError(getViedocInfo?.statusText, "error", "warning"));
    }

    const countryResponse = yield TemplateService.getCountryList();
    if (!countryResponse.data.isError) {
      const countryList = {
        dropDownName: "country",
        result: countryResponse.data.result,
      };
      yield put(actions.getCountrySiteListSuccess(countryList));
    } else {
      yield put(actionsLoader.showError(countryResponse.statusText, "error", "warning"));
    }

    const siteResponse = yield TemplateService.getSiteList();
    if (siteResponse.status === 200) {
      const siteList = {
        dropDownName: "site",
        result: siteResponse.data,
      };
      yield put(actions.getCountrySiteListSuccess(siteList));
    } else {
      yield put(actionsLoader.showError(siteResponse.statusText, "error", "warning"));
    }
    yield put(actions.hideZoneLoader());
  } catch (e) {
    yield put(actions.fetchAllClientApisFailed());
    yield put(actions.hideZoneLoader());
  }
}

export function* getDocumentsBySectionSaga(data) {
  try {
    const response = yield ZoneService.doGetDocumentsBySection(data.payload);
    const { isError, result } = response.data;
    if (!isError) {
      yield put(actions.getDocumentsBySectionSuccess(result));
      if (!_.isEmpty(result.documentDetails)) {
        const sharedData = result.documentDetails.filter(
          (share) => share.artifacturl !== ""
        );
        yield put(templateActions.getSharedDocumentSuccess(sharedData));
      }
    } else {
      yield put(actionsLoader.showError(response.statusText, "error", "warning"));
      yield put(actions.getDocumentsBySectionFailed());
    }
    if (data.isNewDocVersionCreated) {
      yield put(actionsLoader.hideLoader());
    }
  } catch (e) {
    yield put(actions.getDocumentsBySectionFailed());
    yield put(actionsLoader.showError(i18n.t("TMF.TOAST_SOMETHINGWENTWRONG"), "error", "warning"));
  }
}

export function* fetcheTMFMetricsData() {
  const filterInfo = yield StorageHelper.getFilterInfo();
  const defaultValue = "ALL";
  const payload = {
    siteID: filterInfo
      ? filterInfo.selectedSiteID || defaultValue
      : defaultValue,
    countryID: filterInfo
      ? filterInfo.selectedCountryID || defaultValue
      : defaultValue,
  };
  let mileStoneObj = {
    milestoneGroup: "",
    milestoneId: "",
  };
  if (APP_CONST.MILESTONE_GROUP_LIST.includes(filterInfo?.selectedMilestoneID)) {
    mileStoneObj = {
      milestoneGroup: filterInfo
        ? filterInfo.selectedMilestoneID || defaultValue
        : defaultValue,
      milestoneId: "",
    };
  } else {
    mileStoneObj = {
      milestoneGroup: "",
      milestoneId: filterInfo
        ? filterInfo.selectedMilestoneID || defaultValue
        : defaultValue,
    };
  }
  try {
    const response = yield ZoneService.doGetMetricsData({
      ...payload,
      ...mileStoneObj,
    });
    const { result, isError } = response.data;
    if (!isError) {
      const metricData = yield UtilsHelper.constructMetricsInfo(result);
      yield put(actions.fetchMetricsDataSuccess(metricData));
    }
  } catch (error) {
    yield put(actions.fetchMetricsDataFailed());
  }
}

export function* getDocumentsByArtifactSaga(data) {
  try {
    const response = yield ZoneService.doGetDocumentsByArtifact(data.payload);
    const { isError, result } = response.data;
    if (!isError) {
      yield put(actions.getDocumentsBySectionSuccess(result, data.payload));
      const existData = JSON.parse(StorageHelper.getCurrentDocument());
      let documentIds = [];
      if (!_.isEmpty(existData)) {
        existData.map((id) => {
          documentIds.push(id.documentguid);
        })
      }
      if (!_.isEmpty(result.documentDetails)) {
        let sessionData = [];
        result.documentDetails.map((latest) => {
          if (documentIds.includes(latest.documentguid)) {
            sessionData.push(latest);
          }
        })
        Array.prototype.push.apply(sessionData, existData);
        StorageHelper.setCurrentDocument(sessionData);
      }
      if (!_.isEmpty(result.documentDetails)) {
        const sharedData = result.documentDetails.filter((share) => share.artifacturl !== "");
        yield put(templateActions.getSharedDocumentSuccess(sharedData));
      }
      yield put(actions.getDocumentsByArtifactSuccess(result, data.fileguid));
    } else {
      yield put(actionsLoader.showError(response.statusText, "error", "warning"));
      yield put(actions.getDocumentsBySectionFailed(data.payload));
      yield put(actions.getDocumentsByArtifactFailed());
    }
  } catch (e) {
    yield put(actions.getDocumentsBySectionFailed(data.payload));
  }
}

export function* watchZoneAsync() {
  yield takeEvery(actionTypes.FETCH_ALL_CLIENT_APIS, fetchAllClientApiSaga);
  yield takeEvery(
    actionTypes.GET_DOCUMENT_BY_SECTION,
    getDocumentsBySectionSaga
  );
  yield takeEvery(actionTypes.GET_DOCUMENT_BY_ARTIFACT, getDocumentsByArtifactSaga);
  yield takeLatest(actionTypes.FETCH_METRICS_DATA, fetcheTMFMetricsData);
}
